import { render, staticRenderFns } from "./CalendarForm.vue?vue&type=template&id=18bc21f4&"
import script from "./CalendarForm.vue?vue&type=script&lang=ts&"
export * from "./CalendarForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports